import React from 'react';
import { Check, Award, Truck, Users, Shield, Palette, CreditCard, MessageCircle } from 'lucide-react';

const AboutSection = () => {
  const features = [
    {
      icon: Award,
      title: "Kayu Jati Grade A",
      description: "Kayu jati premium yang terkenal dengan kekuatan dan ketahanan luar biasa. Tahan sampai ke anak cucu."
    },
    {
      icon: Palette,
      title: "Ukiran Handmade Jepara",
      description: "Dihasilkan dengan tangan tukang berpengalaman dari Jepara. Boleh tempah ikut citarasa sendiri."
    },
    {
      icon: Users,
      title: "Pelanggan Sanggup Datang Jauh",
      description: "Ramai yang datang dari kampung dan bandar besar semata-mata nak tengok sendiri aura perabot jati."
    },
    {
      icon: Shield,
      title: "Harga Gudang Tanpa Orang Tengah",
      description: "Terus dari Jepara ke gudang kami. Tiada perantara, tiada markup melampau. Jimat besar."
    },
    {
      icon: Truck,
      title: "Servis Hantar Sampai Rumah",
      description: "Hantar terus ke rumah, siap pasang dan susun. Tak perlu angkat barang berat."
    },
    {
      icon: CreditCard,
      title: "Pembayaran Mudah & Flexible",
      description: "Pelan bayaran fleksibel dan mesra pelanggan. Bayar deposit dahulu, selebihnya boleh runding."
    }
  ];

  const stats = [
    { value: "10+", label: "Tahun Pengalaman" },
    { value: "50%", label: "Customer Repeat" },
    { value: "1M+", label: "Follower Media Sosial" },
    { value: "100%", label: "Kayu Jati Asli" },
  ];

  return (
    <section id="tentang" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Kenapa Pilih Gudang Boss Ijan?
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Perabot jati asli terus dari Jepara dengan ukiran halus, kemasan premium dan harga mampu milik.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-4 bg-amber-50 rounded-xl">
              <div className="text-2xl md:text-3xl font-bold text-amber-700">{stat.value}</div>
              <div className="text-xs text-gray-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="p-5 bg-gray-50 rounded-xl hover:bg-amber-50 transition-colors group"
            >
              <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-200 transition-colors">
                <feature.icon className="w-5 h-5 text-amber-700" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="mt-12 text-center p-6 bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl">
          <MessageCircle className="w-8 h-8 text-amber-600 mx-auto mb-3" />
          <p className="text-gray-700 font-medium">
            Lihat sendiri ratusan testimoni video & gambar pelanggan sebenar di media sosial Boss Ijan
          </p>
          <p className="text-sm text-gray-500 mt-1">Bukti kepuasan bukan dibuat-buat!</p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;